<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <span :class="getClass" aria-hidden="true" />
</template>

<script>
export default {
  name: "PlaceholderComponent",
  computed: {
    getClass() {
      const size = "col-" + Math.floor(Math.random() * 12 + 1);
      return `placeholder ${size}`;
    },
  },
};
</script>
